import * as requestLeaseTypes from 'constants/enums/requestLeaseTypes'

export default {
  [requestLeaseTypes.NEW_LEASE_AGREEMENT]: 'Nová nájemní smlouva',
  [requestLeaseTypes.LEASE_AGREEMENT_AMENDMENT]: 'Dodatek k nájemní smlouvě',
  [requestLeaseTypes.LEASE_TERMINATION_AGREEMENT]: 'Dohoda o ukončení nájmu',
  [requestLeaseTypes.OTHER]: 'Ostatní',
} as const
